import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

var ProgressCircleGradient = function (props) {
    var id = props.id, fromColor = props.fromColor, toColor = props.toColor, isValueOver = props.isValueOver, forwardProps = __rest(props, ["id", "fromColor", "toColor", "isValueOver"]);
    return (jsx("svg", __assign({ "aria-hidden": true, style: {
            height: 0,
            position: "absolute",
            display: isValueOver ? "block" : "none",
        } }, forwardProps, { children: jsxs("linearGradient", __assign({ id: id, x1: "40%" }, { children: [jsx("stop", { offset: "0", stopColor: fromColor, stopOpacity: "0" }), jsx("stop", { offset: "1", stopColor: toColor, stopOpacity: "1" })] })) })));
};
ProgressCircleGradient.displayName = "ProgressCircleGradient";

export { ProgressCircleGradient };
//# sourceMappingURL=ProgressCircleGradient.js.map
